import React from "react";
import { Link } from "react-router-dom";
import { CheckCircleIcon, EnvelopeIcon } from "@heroicons/react/24/outline";

const AcitvateAccount = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="backdrop-blur-sm bg-gray-900/20 border border-gray-700/30 rounded-xl p-8 text-center">
                    {/* Success Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="w-16 h-16 bg-emerald-600/20 rounded-full flex items-center justify-center">
                            <CheckCircleIcon className="h-10 w-10 text-emerald-400" />
                        </div>
                    </div>

                    {/* Main Heading */}
                    <h1 className="text-2xl sm:text-3xl font-bold text-white mb-4">
                        Thank you for creating an account
                    </h1>

                    {/* Subtitle */}
                    <p className="text-gray-300 text-base sm:text-lg mb-8 leading-relaxed">
                        Please activate your account from the email we sent you.
                    </p>

                    {/* Email Icon Section */}
                    <div className="bg-gray-800/50 rounded-lg p-4 mb-6">
                        <div className="flex items-center justify-center space-x-3 text-gray-300">
                            <EnvelopeIcon className="h-6 w-6 text-emerald-400" />
                            <span className="text-sm">Check your email inbox</span>
                        </div>
                    </div>

                    {/* Already Activated Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold text-white">
                            Already activated?
                        </h3>
                        
                        <Link
                            to="/login"
                            className="w-full inline-flex items-center justify-center px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-emerald-500/50"
                        >
                            Login to your account
                        </Link>
                    </div>

                    {/* Additional Help */}
                    <div className="mt-6 pt-6 border-t border-gray-700/50">
                        <p className="text-sm text-gray-400">
                            Didn't receive an email? Check your spam folder or contact support.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AcitvateAccount;
